import { ORGANIZATION_MODES } from 'constants/enums'

export default function(value = '') {
  return {
    awardMode: {
      value: value
        ? ORGANIZATION_MODES.offline.id
        : ORGANIZATION_MODES.online.id
    }
  }
}
